/**
 * notViewedNotifications.js
 * Written by: Alex Kasemir
 */
import { createSelector } from 'reselect';
import allNotifications from '../allNotifications';
/**
 * Description of the notViewedNotifications selector
 */

const notViewedNotifications = createSelector(
  [allNotifications],
  (notifications) => notifications.filter((n) => !n.viewed_ts),
);

export default notViewedNotifications;
